export default {
  cpf(v: string) {
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{3})(\d)/, '$1.$2');
    v = v.replace(/(\d{3})(\d)/, '$1.$2');
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    return v;
  },
  cnpj(v: string) {
    if (v.toString().length === 14) {
      v = v.toString().replace(/\D/g, '');
      v = v.toString().replace(/(\d{2})(\d)/, '$1.$2');
      v = v.toString().replace(/(\d{3})(\d)/, '$1.$2');
      v = v.toString().replace(/(\d{3})(\d)/, '$1/$2');
      v = v.toString().replace(/(\d{4})(\d{1,2})$/, '$1-$2');
    } else {
      v = v.toString().replace(/\.|\-|\//g, '');
    }
    return v;
  },
  celular(v: string) {
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{2})(\d)/, '($1) $2');
    v = v.replace(/(\d{5})(\d)/, '$1-$2');
    return v;
  },
  semPontoTracoBarra(v: string) {
    return v.toString().replace(/\.|\-|\//g, '');
  },
};
